// function lockScroll() {
//   const scrollX = window.scrollX;
//   const scrollY = window.scrollY;

//   // Lock the scroll position
//   document.body.style.position = 'fixed';
//   document.body.style.top = `-${scrollY}px`;
//   document.body.style.left = `-${scrollX}px`;
//   document.body.style.overflow = 'scroll';
// }

// function unlockScroll() {
//   const scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
//   const scrollX = Math.abs(parseInt(document.body.style.left || '0', 10));

//   // Unlock and reset scroll position
//   document.body.style.position = '';
//   document.body.style.top = '';
//   document.body.style.left = '';
//   window.scrollTo(scrollX, scrollY);
// }

// if(screen.width > 767){
// document.querySelectorAll('product-info[data-url="/products/gift-card"] .product-form__input--pill label.js-value').forEach(variant => {
//   variant.addEventListener('click', function() {
    
//   const scrollX = window.scrollX;
//   const scrollY = window.scrollY;
//     console.log(scrollX,scrollY);
//   if(scrollY<100){
//     lockScroll(); // Lock scroll during action
//     setTimeout(unlockScroll, 100); // Restore scroll after 500ms
//   }
//   });
// });
// }

// =================================================================================================
// Sizing Guide
// =================================================================================================
 // console.log("TeeTurtle");

  // Full Sizing Guide Page
  var menFullSizingTable = document.getElementById("menFullSizingTable");
  var womenFullSizingTable = document.getElementById("womenFullSizingTable");
  var kidFullSizingTable = document.getElementById("kidFullSizingTable");
  var sweatshirtFullSizingTable = document.getElementById("sweatshirtFullSizingTable");
  
  function updateMenSizingPage () {
      var country = document.getElementById("mensDropdown").value;
      if (country === "US"){
          menFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (in)</strong></td><td>28</td><td>29</td><td>30.5</td><td>31</td><td>32</td><td>33</td></tr><tr><td><strong>Chest Width (in)</strong></td><td>17.5</td><td>20</td><td>22</td><td>24</td><td>26</td><td>28</td></tr><tr><td><strong>Sleeve Length (in)</strong></td><td>14</td><td>14.5</td><td>16</td><td>16.5</td><td>17.5</td><td>19</td></tr></table>";
      }else if(country === "UK/EU"){
          menFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (cm)</strong></td><td>71.5</td><td>73.5</td><td>77.5</td><td>78</td><td>81.5</td><td>83.5</td></tr><tr><td><strong>Chest Width (cm)</strong></td><td>45</td><td>51</td><td>55.5</td><td>61</td><td>65.5</td><td>71</td></tr><tr><td><strong>Sleeve Length (cm)</strong></td><td>35</td><td>37</td><td>40.5</td><td>42</td><td>44</td><td>49</td></tr></table>";
      }
  }
  
  function updateWomenSizingPage () {
      var country = document.getElementById("womensDropdown").value;
      if (country === "US"){
          womenFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (in)</strong></td><td>24.5</td><td>24.5</td><td>25.5</td><td>26.5</td><td>27.5</td><td>29</td><td>31</td></tr><tr><td><strong>Chest Width (in)</strong></td><td>16</td><td>18</td><td>19</td><td>21</td><td>23</td><td>24</td><td>27</td></tr><tr><td><strong>Sleeve Length (in)</strong></td><td>9</td><td>9.5</td><td>10</td><td>11</td><td>12</td><td>12.5</td><td>13</td></tr></table>";
      }else if(country === "UK/EU"){
          womenFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (cm)</strong></td><td>62</td><td>62.5</td><td>65.5</td><td>67.5</td><td>70</td><td>73.5</td><td>78.5</td></tr><tr><td><strong>Chest Width (cm)</strong></td><td>40.5</td><td>45.5</td><td>47.5</td><td>53</td><td>58.5</td><td>61</td><td>68.5</td></tr><tr><td><strong>Sleeve Length (cm)</strong></td><td>23</td><td>25</td><td>25.5</td><td>28</td><td>30</td><td>32</td><td>33</td></tr></table>";
      }
  }
  
  function updateKidSizingPage () {
      var country = document.getElementById("kidsDropdown").value;
      if (country === "US"){
          kidFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th></tr><tr><td><strong>Shirt Length (in)</strong></td><td>22</td><td>23</td><td>25</td></tr><tr><td><strong>Chest Width (in)</strong></td><td>15</td><td>16.5</td><td>17.5</td></tr><tr><td><strong>Sleeve Length (in)</strong></td><td>10</td><td>10.5</td><td>12</td></tr></table>";
      }else if(country === "UK/EU"){
          kidFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th></tr><tr><td><strong>Shirt Length (cm)</strong></td><td>55.5</td><td>58</td><td>63</td></tr><tr><td><strong>Chest Width (cm)</strong></td><td>38</td><td>42</td><td>45</td></tr><tr><td><strong>Sleeve Length (cm)</strong></td><td>25</td><td>27</td><td>30</td></tr></table>";
      }
  }
  
  function updateSweatshirtSizingPage () {
      var country = document.getElementById("sweatshirtDropdown").value;
      if (country === "US"){
          sweatshirtFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (in)</strong></td><td>27</td><td>28</td><td>29</td><td>30</td><td>31</td><td>32</td></tr><tr><td><strong>Chest Width (in)</strong></td><td>19.5</td><td>21.5</td><td>23.5</td><td>25.5</td><td>27.5</td><td>29.5</td></tr><tr><td><strong>Sleeve Length (in)</strong></td><td>24</td><td>24.5</td><td>25</td><td>25.5</td><td>26</td><td>26.5</td></tr></table>";
      }else if(country === "UK/EU"){
          sweatshirtFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (cm)</strong></td><td>68.5</td><td>71</td><td>74</td><td>76</td><td>79</td><td>81</td></tr><tr><td><strong>Chest Width (cm)</strong></td><td>49.5</td><td>54.5</td><td>60</td><td>65</td><td>70</td><td>75</td></tr><tr><td><strong>Sleeve Length (cm)</strong></td><td>61</td><td>62</td><td>63.5</td><td>65</td><td>66</td><td>67</td></tr></table>";
      }
  }
  
// =================================================================================================
// Back to Top Button
// =================================================================================================
  
  let scrollTopBtn = document.getElementById("scrollBtn");
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener("click", function () {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    });
  }
  
  function scrollFunction() {
    if (scrollTopBtn) {
      // When the user scrolls down 20px from the top of the document, show the button
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        scrollTopBtn.style.display = 'block';
      } else {
        scrollTopBtn.style.display = 'none';
      }
    }
  }

  window.onscroll = function() {
    scrollFunction();
  };

  window.onload = function() {
    scrollFunction();
  };

// =================================================================================================
// USD Currency
// =================================================================================================

const priceList = document.getElementsByClassName("price__current");

for(let i=0; i<priceList.length; i++){
    if(priceList[i].innerText.includes("USD")){
        priceList[i].innerText = priceList[i].innerText.slice(0,-4);
    }
}

// =================================================================================================
// product sticky Button
// =================================================================================================
  
 var offsetSticky = document.querySelector("product-info.product__info-container"); 
 var cartSticky = document.querySelector("sticky-atc-panel.sticky-atc-panel"); 
 if (offsetSticky != null && cartSticky != null) {
  window.onscroll = function() {productAddtocartSticky()};  
  function productAddtocartSticky() { 
      var sticky = offsetSticky.offsetTop + 400;  
    if (window.pageYOffset > sticky) {
      cartSticky.classList.add("is__active");  
    } 
    else {
      cartSticky.classList.remove("is__active");  
    } 
   }
  let scrollTopBtn = document.querySelector(".sticky__product_button .button--ouline");
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener("click", function (evt) {
       evt.preventDefault();
      offsetSticky.offsetTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    });
  } 
}

// ==================================start=jquey=code===============================//
 

$(document).ready(function(){
  
  $("details.mega-menu summary.list-menu__item").hover(function () {
    $(this).parents('details.mega-menu').attr('open', 'open');
}, 
 function () {
       // $(this).parents('details.mega-menu').removeAttr('open', 'open');
});
  
$(document).on("click",".footer-block--menu .footer-block__heading",function(evt){
  evt.preventDefault();
  $(this).toggleClass("is--active");
  $(this).parents(".footer-block--menu").find('.footer-block__details-content').toggleClass("is--active");
  // // $(".footer-block__details-content").removeClass("is--active"); $(".footer-block__details-content").hide();
  // $(this).parents(".footer-block--menu").find('.footer-block__details-content').show();
});

// ====product page js ============// 
  
  $(document).on("click",".product-form__input--pill input[type=radio] + label",function(){
    setTimeout(function() {
    var priceHtml = $('product-info .product_block_price').html();
    $('.product_price_title-mobilde .product_block_price').html(priceHtml);
   }, 2000);
});

// ====collection page js ============// 
  $(document).on("click","span.sort__icons",function(event) { 
  event.preventDefault();
  $("ul.collection-sort-list").slideToggle();
  // $(".collection-sort-list-select").slideToggle();
});
 
// $(document).on("click","ul.collection-sort-list a",function(event) { 
//    event.preventDefault();
//   var thisVal = $(this).data('value');
//    $("select.facet-filters__sort option").removeAttr('selected'); 
//    $(this).parents('.facet-filters__field').find("select.facet-filters__sort option").each(function(){ 
//     var optionval= $(this).val(); 
//      if (optionval == thisVal){     
//         $(this).attr('selected','selected');
       
//        $(this).parents('.facet-filters__field').find("select.facet-filters__sort").val(optionval).change();  
//      }
//   }); 
// });

  
   // $(document).on('click','.itg-load-more a',function(e){
   //          e.preventDefault(); var thisButton = $(this);
   //        // var thisButton = $('.itg-load-more a');
   //           thisButton.text('Loading..');
   //          var scrollURL = $(this).attr('href');
   //          var pageAll = parseInt(thisButton.data('value'));
   //          var pageCount = parseInt(thisButton.data('page')); 
   //          $.ajax({
   //            type: 'GET',
   //            url: scrollURL,
   //            beforeSend: function() { 
   //            },
   //            success: function(data) {
   //              thisButton.hide();
   //              var filteredData = $(data).find("#product-grid").html();
   //              var itgLoadMore = $(data).find(".itg-load-more").html();
   //              var itgfilter = $(data).find(".facets-container").html();
   //              $(document).find("#product-grid").append(filteredData);
   //               $(document).find(".facets-container").html(itgfilter); 
   //              $(document).find(".itg-load-more").html(itgLoadMore); 
   //              // thisButton.text('Load More').show();
   //              thisButton.text('Load More');
   //               if (pageAll = pageCount){
   //               thisButton.hide();
   //             } else {
   //               thisButton.show();
   //             }
   //            },
   //            dataType: "html"
   //          });
   //      });
 
  
// ====collection page best selling ============// 
var itg_itemcount = $('.itg_itemcount').length;
var itg_itemcount = 18 - itg_itemcount;
$(".itg_gird #product-grid li.grid__item").slice(0, itg_itemcount).show();
$('.itg_gird .itg-load-more').hide();

     $(document).on('click','.itg_custom_more',function(e){ 
    e.preventDefault();
    $(".itg_gird #product-grid li.grid__item:hidden")
      .slice(0, 18)
      .fadeIn("slow");
    if (
      $(".itg_gird #product-grid li.grid__item:hidden").length == 0 ||
      $(".itg_gird #product-grid li.grid__item").length == 0
    ) {
      $(".itg_custom_more").fadeOut("slow");
      $('.itg_gird .itg-load-more').show();
    }
  });
  
  $(document).scroll(function (e) {
  $('.itg_gird .itg_custom_more').show();
  });

  // itg js


     let fOpt = $('.product-form__inputpills-1 input[type=radio]:checked').val();
     $('fieldset.product-form__inputpills-2 label.itg_disable').addClass('its-disable');
     $('fieldset.product-form__inputpills-3 label.itg_disable').addClass('its-disable');
     let sOpt = $('.product-form__inputpills-2 input[type=radio]:checked').val();
     $('select#get-var option').each(function(){
       var dataVal = $(this).data('title').split(' / ');
       if(dataVal[0] == fOpt){
         $(`label.itg_disable[data-value="${dataVal[1]}"]`).removeClass('its-disable');
         if($('.product-form__inputpills-3 input[type=radio]:checked').length){
           if(dataVal[1] == sOpt){
             $(`label.itg_disable[data-value="${dataVal[2]}"]`).removeClass('its-disable');
             console.log(dataVal);
           }
         }
       }
     });
   $(document).on('change','.product-form__input input',function() {
     let tLength = $('.product-form__inputpills-3').length;
     let sLength = $('.product-form__inputpills-2').length;
     if(tLength || sLength){
       let fOpt = $('.product-form__inputpills-1 input[type=radio]:checked').val();
       let sOpt = $('.product-form__inputpills-2 input[type=radio]:checked').val();
       let tOpt = '';
       let mainVal = '';
       if(tLength){
          tOpt = $('.product-form__inputpills-3 input[type=radio]:checked').val();
       }
       if($(this).parents('.product-form__inputpills-1')){
         $('fieldset.product-form__inputpills-2 label.itg_disable').addClass('its-disable');
         $('fieldset.product-form__inputpills-3 label.itg_disable').addClass('its-disable');
         $('select#get-var option').each(function(){
           var dataVal = $(this).data('title');
           let fVal = dataVal.split(' / ')[0];
           if(fVal == fOpt){
             let sVal = dataVal.split(' / ')[1];
             $(`label.itg_disable[data-value="${sVal}"]`).removeClass('its-disable');
             let tVal = '';
              if(tLength){
               tVal = dataVal.split(' / ')[2];
               $(`label.itg_disable[data-value="${tVal}"]`).removeClass('its-disable');
              }
           }
         });
       }
       if($(this).parents('.product-form__inputpills-2') && tLength){
         $('fieldset.product-form__inputpills-3 label.itg_disable').addClass('its-disable');
         $('select#get-var option').each(function(){
           var dataVal = $(this).data('title');
           let sVal = dataVal.split(' / ')[1];
           if(sVal == sOpt){
             let tVal = dataVal.split(' / ')[2];
             $(`label.itg_disable[data-value="${tVal}"]`).removeClass('its-disable');
           }
         });
          // $(document).find('.product-form__inputpills-2 label').each(function() {
          //      var thscls = $(this).hasClass('its-disable');
          //      if(thscls == false){
          //        $(this).click();
          //        return false;
          //      }
          //   });
       }
     }
   });
  
});


// =================================================================================================
// Conventions Catalog
// =================================================================================================

var currentLink = window.location.href;
var TeeTurtleHeader = document.getElementsByClassName("shopify-section-group-header-group");
var TeeTurtleFooter = document.getElementsByClassName("footer");


if(currentLink.slice(-19) === "conventions-catalog") {
    for(let x=0; x < TeeTurtleHeader.length; x++){
        TeeTurtleHeader[x].classList.add("hidden-content");
    }
    for(let y=0; y < TeeTurtleFooter.length; y++){
        TeeTurtleFooter[y].classList.add("hidden-content");
    }
}else{
    for(let x=0; x < TeeTurtleHeader.length; x++){
        TeeTurtleHeader[x].classList.remove("hidden-content");
    }
    for(let y=0; y < TeeTurtleFooter.length; y++){
        TeeTurtleFooter[y].classList.remove("hidden-content");
    }
}


// =================================================================================================
// New Tab Pages
// =================================================================================================

var wikiPage = document.getElementById("HeaderMenu-unstable-games-wiki");
wikiPage.setAttribute("target", "_blank");

var wikiPage2 = document.getElementById("button-Check it out");
wikiPage2.setAttribute("target", "_blank");

var wikiPage3 = document.getElementById("HeaderDrawer-unstable-games-wiki");
wikiPage3.setAttribute("target", "_blank");

var webComic = document.getElementById("Unstable Unicorns: The Webcomic");
webComic.setAttribute("target", "_blank");

var socialLinks = document.getElementsByClassName("list-social__link");
for (let i = 0; i < socialLinks.length; i++) {
  socialLinks[i].setAttribute("target", "_blank");
}

var TwistedCryptidsKSDesktop = document.getElementById("HeaderMenu-twisted-cryptids-kickstarter");
TwistedCryptidsKSDesktop.setAttribute("target", "_blank");

var TwistedCryptidsKSMobile = document.getElementById("HeaderDrawer-twisted-cryptids-kickstarter");
TwistedCryptidsKSMobile.setAttribute("target", "_blank");

// =================================================================================================
// Uncapitalize "shirt"
// =================================================================================================

var filterLinks = document.getElementsByClassName("facet-checkbox__text");
for (let i = 0; i < filterLinks.length; i++) {
  if(filterLinks[i].innerText === "Premium Cotton T-shirt " || filterLinks[i].innerText === "Premium Cotton T-shirt" || filterLinks[i].innerText === "Premium Cotton T-Shirt " || filterLinks[i].innerText === "Premium Cotton T-Shirt"){
    filterLinks[i].setAttribute("style", "text-transform: none;")
  }
}
